import { IonContent } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { PRIVACY_LINK, TERMS_LINK } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { NavigationRange } from '@/pages/Onboarding/components/NavigationRange';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';

import { ScreenSecurityStyles } from './Security.styles';

export const ScreenSecurity: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Security',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = (): void => {
    wizard.nextStep();
  };

  const handleBack = (): void => {
    wizard.goToStep('major_turn_off');
  };

  return (
    <ScreenSecurityStyles background="dark-violet">
      <NavigationRange onBack={handleBack} />

      <OwnAiTitle>
        Dialogue prioritizes and protects your personal information
      </OwnAiTitle>
      <IonContent scrollY={false}>
        <div className="description">
          <OwnAiTitle>What happens in Dialogue, stays in Dialogue</OwnAiTitle>
        </div>

        <Player
          src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/lock-animation-dark.json"
          autoplay
          loop={false}
          keepLastFrame
          className="animation"
        />

        <UiTypography className="disclaimer" variant="label-small">
          We never disclose your information. By tapping on Continue, you agree
          with our
          <a className="link" href={PRIVACY_LINK} target="_blank">
            Privacy Policy
          </a>{' '}
          and
          <a className="link" href={TERMS_LINK} target="_blank">
            Terms of Use
          </a>
        </UiTypography>
      </IonContent>

      <OnboardingFooter buttonColor="pink" onContinue={handleNextStep} />
    </ScreenSecurityStyles>
  );
};
